/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { FormOrgLevelMetadataSettings } from 'redux/schemas/models/org-level-metadata-settings';
import t from 'react-translate';
import { AlertMessageType } from 'redux/schemas/app/alert-message';
import { addAlertMessage } from 'redux/actions/alert-messages';

const savingCallOrgLevelMetadataSettings = payload => (
  axios.post(
    'metadata_fields.json',
    payload.form,
  ).then(response => ({ metadataFields: response.data.result })).catch((error) => {
    throw (error.response?.data?.error);
  })
);

export const saveOrgLevelMetadataSettings = createAsyncThunk(
  'SAVE_ORG_LEVEL_METADATA_SETTINGS',
  (payload: {
    institutionId: number,
    form: FormOrgLevelMetadataSettings,
  }) => savingCallOrgLevelMetadataSettings(payload),
);

async function toggleLearningCatalog(params, { dispatch, rejectWithValue }) {
  try {
    const { institutionId, enabled } = params;
    const response = await axios.put(`/institutions/${institutionId}/toggle_discovery_enabled`,
      {
        discoveryEnabled: enabled,
      });
    return response.data.result;
  } catch (error) {
    dispatch(addAlertMessage({
      type: AlertMessageType.ERROR,
      header: t.FORM.OOPS(),
      message: t.FORM.ERROR_SOMETHING_WRONG(),
    }));
    return rejectWithValue(error);
  }
}

export const enableLearningCatalog = createAsyncThunk(
  'LOAD_LECTURE_PAGE_ACTIVITIES',
  toggleLearningCatalog,
);

